// このファイルは自動生成されています。手動で編集しないでください。
// 生成元: acomo-backend/openapi.json
// 生成コマンド: npm run generate:params

export interface ParamInfo {
  name: string;
  in: 'path' | 'query';
  required: boolean;
  type: string;
  description: string;
  example?: unknown;
}

export interface BodyPropertyInfo {
  name: string;
  type: string;
  description: string;
  required: boolean;
  example?: unknown;
}

export interface OperationParamInfo {
  httpMethod: string;
  path: string;
  params: ParamInfo[];
  requestBody?: {
    dtoName: string;
    properties: BodyPropertyInfo[];
  };
}

export const operationParams: Record<string, OperationParamInfo> = {
  "approveWorkflowProcess": {
    httpMethod: "POST",
    path: "/api/v1/engine/approve/{processId}",
    params: [
      { name: "processId", in: "path", required: true, type: "string", description: "" }
    ],
    requestBody: {
      dtoName: "body",
      properties: [

      ]
    }
  },
  "approveWorkflowProcessWithNodeId": {
    httpMethod: "POST",
    path: "/api/v1/engine/approve/{processId}/{nodeId}",
    params: [
      { name: "processId", in: "path", required: true, type: "string", description: "" },
      { name: "nodeId", in: "path", required: true, type: "string", description: "" }
    ],
    requestBody: {
      dtoName: "body",
      properties: [

      ]
    }
  },
  "connectivityTest": {
    httpMethod: "POST",
    path: "/api/v1/slack/connectivityTest",
    params: [

    ]
  },
  "convertExpression": {
    httpMethod: "GET",
    path: "/api/v1/models/convertExpression/{expressionString}",
    params: [
      { name: "expressionString", in: "path", required: true, type: "string", description: "" }
    ]
  },
  "createCompanionSession": {
    httpMethod: "POST",
    path: "/api/v1/authentication/session/companion",
    params: [

    ],
    requestBody: {
      dtoName: "createCompanionSessionDto",
      properties: [
        { name: "sessionName", type: "string", description: "セッション名（用途識別子）。同一 auth tenant × ユーザー × sessionName で companion セッションは常に1本になる（置き換え）。\n「サービス名-用途」の形式を推奨する。", required: true, example: "b-workflow-slack" }
      ]
    }
  },
  "createCorsOrigins": {
    httpMethod: "POST",
    path: "/api/v1/cors",
    params: [

    ],
    requestBody: {
      dtoName: "createCorsAllowedOriginDto",
      properties: [
        { name: "url", type: "string", description: "", required: true },
        { name: "description", type: "string", description: "", required: true }
      ]
    }
  },
  "createGroup": {
    httpMethod: "POST",
    path: "/api/v1/groups",
    params: [

    ]
  },
  "createMyOrganization": {
    httpMethod: "POST",
    path: "/api/v1/account/my/organization",
    params: [

    ]
  },
  "createMyOrganizationsTenant": {
    httpMethod: "POST",
    path: "/api/v1/account/my/organization/tenants",
    params: [

    ],
    requestBody: {
      dtoName: "createTenantDto",
      properties: [
        { name: "authTenantId", type: "string", description: "AuthテナントID", required: true },
        { name: "name", type: "string", description: "テナント名", required: true }
      ]
    }
  },
  "createOrUpdateAuthConfigsIdentityProvider": {
    httpMethod: "PUT",
    path: "/api/v1/authConfig/identityProviders",
    params: [

    ],
    requestBody: {
      dtoName: "createOrUpdateIdentityProviderDto",
      properties: [
        { name: "thirdPartyType", type: "\"google\" | \"github\" | \"gitlab\" | \"slack\" | \"custom\"", description: "サードパーティ種別", required: true, example: "google" },
        { name: "thirdPartyId", type: "string", description: "サードパーティId", required: false, example: "google" },
        { name: "name", type: "string", description: "認証プロバイダー名", required: true, example: "Google" },
        { name: "clientId", type: "string", description: "クライアントID", required: true },
        { name: "clientSecret", type: "string", description: "クライアントシークレット", required: true },
        { name: "oidcDiscoveryEndpoint", type: "string", description: "OIDCディスカバリーエンドポイント", required: false },
        { name: "scope", type: "string[]", description: "OAuth Scope", required: false }
      ]
    }
  },
  "createResetPasswordLink": {
    httpMethod: "POST",
    path: "/api/v1/authentication/createResetPasswordLink",
    params: [

    ]
  },
  "createRole": {
    httpMethod: "POST",
    path: "/api/v1/roles",
    params: [

    ]
  },
  "createSetting": {
    httpMethod: "POST",
    path: "/api/v1/settings",
    params: [

    ]
  },
  "createUser": {
    httpMethod: "POST",
    path: "/api/v1/users",
    params: [

    ]
  },
  "createWorkflowModel": {
    httpMethod: "POST",
    path: "/api/v1/models",
    params: [

    ],
    requestBody: {
      dtoName: "createModelDto",
      properties: [
        { name: "name", type: "string", description: "モデル名", required: true, example: "経費申請・承認フロー" },
        { name: "description", type: "string", description: "説明", required: false, example: "経費申請の承認を行います。" },
        { name: "definition", type: "object", description: "ワークフロー定義", required: true },
        { name: "dataSchema", type: "object", description: "データスキーマ", required: true },
        { name: "policy", type: "object", description: "データアクセスポリシー", required: true }
      ]
    }
  },
  "deleteAuthConfigsIdentityProvider": {
    httpMethod: "DELETE",
    path: "/api/v1/authConfig/identityProviders/{thirdPartyId}",
    params: [
      { name: "thirdPartyId", in: "path", required: true, type: "string", description: "" }
    ]
  },
  "deleteCorsOrigins": {
    httpMethod: "DELETE",
    path: "/api/v1/cors/{id}",
    params: [
      { name: "id", in: "path", required: true, type: "string", description: "" }
    ]
  },
  "deleteMailTemplate": {
    httpMethod: "DELETE",
    path: "/api/v1/mailTemplates/{type}",
    params: [
      { name: "type", in: "path", required: true, type: "string", description: "" }
    ]
  },
  "deleteMyOrganizationsTenant": {
    httpMethod: "DELETE",
    path: "/api/v1/account/my/organization/tenants/{tenantId}",
    params: [
      { name: "tenantId", in: "path", required: true, type: "string", description: "", example: "1" }
    ]
  },
  "deleteMyProcessDataFile": {
    httpMethod: "POST",
    path: "/api/v1/my/processes/{processId}/files/delete",
    params: [
      { name: "processId", in: "path", required: true, type: "string", description: "", example: "1" }
    ],
    requestBody: {
      dtoName: "createProcessFileDto",
      properties: [
        { name: "property", type: "string", description: "プロパティ（データ項目名）", required: true, example: "attachmentFiles" },
        { name: "fileName", type: "string", description: "ファイル名", required: true, example: "領収書.pdf" }
      ]
    }
  },
  "deleteProcessDataFile": {
    httpMethod: "POST",
    path: "/api/v1/processes/{processId}/files/delete",
    params: [
      { name: "processId", in: "path", required: true, type: "string", description: "", example: "1" }
    ],
    requestBody: {
      dtoName: "createProcessFileDto",
      properties: [
        { name: "property", type: "string", description: "プロパティ（データ項目名）", required: true, example: "attachmentFiles" },
        { name: "fileName", type: "string", description: "ファイル名", required: true, example: "領収書.pdf" }
      ]
    }
  },
  "deleteWorkflowModel": {
    httpMethod: "DELETE",
    path: "/api/v1/models/{modelId}",
    params: [
      { name: "modelId", in: "path", required: true, type: "string", description: "", example: "1" }
    ]
  },
  "deleteWorkflowProcess": {
    httpMethod: "DELETE",
    path: "/api/v1/processes/{processId}",
    params: [
      { name: "processId", in: "path", required: true, type: "string", description: "", example: "1" }
    ]
  },
  "enableMySubscriptions": {
    httpMethod: "POST",
    path: "/api/v1/account/my/organization/subscriptions/enable",
    params: [

    ]
  },
  "generateToken": {
    httpMethod: "POST",
    path: "/api/v1/clientAuth/oauth/token",
    params: [

    ]
  },
  "getAccessToken": {
    httpMethod: "GET",
    path: "/api/v1/clientAuth/{clientAccessTokenId}",
    params: [
      { name: "clientAccessTokenId", in: "path", required: true, type: "string", description: "" }
    ]
  },
  "getAccount": {
    httpMethod: "GET",
    path: "/api/v1/account",
    params: [

    ]
  },
  "getAgentAssistantAvailability": {
    httpMethod: "GET",
    path: "/api/v1/ai/status/agent-assistant-availability",
    params: [

    ]
  },
  "getAuthConfig": {
    httpMethod: "GET",
    path: "/api/v1/authConfig",
    params: [

    ]
  },
  "getChannels": {
    httpMethod: "GET",
    path: "/api/v1/slack/channels",
    params: [

    ]
  },
  "getClientCredentialsAvailability": {
    httpMethod: "GET",
    path: "/api/v1/clientAuth/status/client-credentials-availability",
    params: [

    ]
  },
  "getCorsOrigins": {
    httpMethod: "GET",
    path: "/api/v1/cors/{id}",
    params: [
      { name: "id", in: "path", required: true, type: "string", description: "" }
    ]
  },
  "getCurrentTenant": {
    httpMethod: "GET",
    path: "/api/v1/profile/tenant",
    params: [

    ]
  },
  "getCurrentUser": {
    httpMethod: "GET",
    path: "/api/v1/profile/user",
    params: [

    ]
  },
  "getDiffs": {
    httpMethod: "GET",
    path: "/api/v1/processes/{processId}/diffs",
    params: [
      { name: "processId", in: "path", required: true, type: "string", description: "", example: "1" }
    ]
  },
  "getGroup": {
    httpMethod: "GET",
    path: "/api/v1/groups/{groupId}",
    params: [
      { name: "groupId", in: "path", required: true, type: "string", description: "", example: "1" }
    ]
  },
  "getIdentityProvider": {
    httpMethod: "GET",
    path: "/api/v1/authConfig/identityProviders/{thirdPartyId}",
    params: [
      { name: "thirdPartyId", in: "path", required: true, type: "string", description: "" }
    ]
  },
  "getIdentityProviders": {
    httpMethod: "GET",
    path: "/api/v1/authConfig/identityProviders",
    params: [
      { name: "authTenantId", in: "query", required: true, type: "string", description: "AuthテナントID", example: "mytenant-xhwpda" }
    ]
  },
  "getMyCheckoutUrl": {
    httpMethod: "POST",
    path: "/api/v1/account/subscriptions/checkout",
    params: [

    ],
    requestBody: {
      dtoName: "subscribeDto",
      properties: [
        { name: "authTenantId", type: "string", description: "", required: true },
        { name: "planName", type: "string", description: "", required: true },
        { name: "quantity", type: "number", description: "", required: true },
        { name: "successUrl", type: "string", description: "", required: true },
        { name: "cancelUrl", type: "string", description: "", required: true },
        { name: "isTrial", type: "boolean", description: "", required: true }
      ]
    }
  },
  "getMyCustomerPortalUrl": {
    httpMethod: "POST",
    path: "/api/v1/account/subscriptions/portal",
    params: [

    ],
    requestBody: {
      dtoName: "customerPortalDto",
      properties: [
        { name: "returnUrl", type: "string", description: "", required: true }
      ]
    }
  },
  "getMyDiffs": {
    httpMethod: "GET",
    path: "/api/v1/my/processes/{processId}/diffs",
    params: [
      { name: "processId", in: "path", required: true, type: "string", description: "", example: "1" }
    ]
  },
  "getMyModel": {
    httpMethod: "GET",
    path: "/api/v1/my/models/{modelId}",
    params: [
      { name: "modelId", in: "path", required: true, type: "string", description: "" },
      { name: "nodeActionType", in: "query", required: false, type: "string", description: "特定のアクションが可能なモデルに絞り込みます。" }
    ]
  },
  "getMyOrganization": {
    httpMethod: "GET",
    path: "/api/v1/account/my/organization",
    params: [

    ]
  },
  "getMyOrganizationsTenant": {
    httpMethod: "GET",
    path: "/api/v1/account/my/organization/tenants/{tenantId}",
    params: [
      { name: "tenantId", in: "path", required: true, type: "string", description: "" }
    ]
  },
  "getMyOrganizationsTenantPlanStatus": {
    httpMethod: "GET",
    path: "/api/v1/account/my/organization/tenants/{tenantId}/plan",
    params: [
      { name: "tenantId", in: "path", required: true, type: "string", description: "" }
    ]
  },
  "getMyProcessDataFileDownloadUrl": {
    httpMethod: "POST",
    path: "/api/v1/my/processes/{processId}/files/getDownloadUrl",
    params: [
      { name: "processId", in: "path", required: true, type: "string", description: "", example: "1" },
      { name: "disposition", in: "query", required: true, type: "string", description: "" }
    ],
    requestBody: {
      dtoName: "createProcessFileDto",
      properties: [
        { name: "property", type: "string", description: "プロパティ（データ項目名）", required: true, example: "attachmentFiles" },
        { name: "fileName", type: "string", description: "ファイル名", required: true, example: "領収書.pdf" }
      ]
    }
  },
  "getMyProcesses": {
    httpMethod: "GET",
    path: "/api/v1/my/processes/{processId}",
    params: [
      { name: "processId", in: "path", required: true, type: "string", description: "" },
      { name: "processHistoryType", in: "query", required: false, type: "string", description: "actioned=trueのとき、アクション履歴種別で絞り込みます。actioned=falseの場合は、このパラメーターは無視されます。" },
      { name: "nodeActionType", in: "query", required: false, type: "string", description: "permitted=trueのとき、指定したアクションが可能なプロセスに絞り込みます。permitted=falseの場合は、このパラメーターは無視されます。" },
      { name: "actioned", in: "query", required: false, type: "boolean", description: "trueを指定すると、ユーザーがアクションしたプロセスに絞り込みます。" },
      { name: "permitted", in: "query", required: false, type: "boolean", description: "trueを指定すると、ユーザーがアクション可能なプロセスに絞り込みます。" }
    ]
  },
  "getMyProcessesWithNodeId": {
    httpMethod: "GET",
    path: "/api/v1/my/processes/{processId}/{nodeId}",
    params: [
      { name: "processId", in: "path", required: true, type: "string", description: "" },
      { name: "nodeId", in: "path", required: true, type: "string", description: "" },
      { name: "processHistoryType", in: "query", required: false, type: "string", description: "actioned=trueのとき、アクション履歴種別で絞り込みます。actioned=falseの場合は、このパラメーターは無視されます。" },
      { name: "nodeActionType", in: "query", required: false, type: "string", description: "permitted=trueのとき、指定したアクションが可能なプロセスに絞り込みます。permitted=falseの場合は、このパラメーターは無視されます。" },
      { name: "actioned", in: "query", required: false, type: "boolean", description: "trueを指定すると、ユーザーがアクションしたプロセスに絞り込みます。" },
      { name: "permitted", in: "query", required: false, type: "boolean", description: "trueを指定すると、ユーザーがアクション可能なプロセスに絞り込みます。" }
    ]
  },
  "getMySubscriptions": {
    httpMethod: "GET",
    path: "/api/v1/account/my/organization/subscriptions",
    params: [
      { name: "organizationId", in: "path", required: true, type: "string", description: "" }
    ]
  },
  "getMySubscriptionsCheckoutUrl": {
    httpMethod: "POST",
    path: "/api/v1/account/my/organization/subscriptions/checkout",
    params: [

    ],
    requestBody: {
      dtoName: "subscribeDto",
      properties: [
        { name: "authTenantId", type: "string", description: "", required: true },
        { name: "planName", type: "string", description: "", required: true },
        { name: "quantity", type: "number", description: "", required: true },
        { name: "successUrl", type: "string", description: "", required: true },
        { name: "cancelUrl", type: "string", description: "", required: true },
        { name: "isTrial", type: "boolean", description: "", required: true }
      ]
    }
  },
  "getMySubscriptionsCustomerPortalUrl": {
    httpMethod: "POST",
    path: "/api/v1/account/my/organization/subscriptions/portal",
    params: [

    ],
    requestBody: {
      dtoName: "customerPortalDto",
      properties: [
        { name: "returnUrl", type: "string", description: "", required: true }
      ]
    }
  },
  "getMyTenants": {
    httpMethod: "GET",
    path: "/api/v1/account/tenants",
    params: [

    ]
  },
  "getMyTenantsWithSignInMethod": {
    httpMethod: "GET",
    path: "/api/v1/account/tenants/signInMethod",
    params: [

    ]
  },
  "getMyTrialSubscription": {
    httpMethod: "GET",
    path: "/api/v1/account/subscriptions/trial",
    params: [

    ]
  },
  "getMyUserAuthInfo": {
    httpMethod: "GET",
    path: "/api/v1/authentication/userAuthInfo",
    params: [

    ]
  },
  "getProcessDataFileDownloadUrl": {
    httpMethod: "POST",
    path: "/api/v1/processes/{processId}/files/getDownloadUrl",
    params: [
      { name: "processId", in: "path", required: true, type: "string", description: "", example: "1" },
      { name: "disposition", in: "query", required: true, type: "string", description: "" }
    ],
    requestBody: {
      dtoName: "createProcessFileDto",
      properties: [
        { name: "property", type: "string", description: "プロパティ（データ項目名）", required: true, example: "attachmentFiles" },
        { name: "fileName", type: "string", description: "ファイル名", required: true, example: "領収書.pdf" }
      ]
    }
  },
  "getProcessWithNodeActions": {
    httpMethod: "GET",
    path: "/api/v1/my/processes/nodeActions/{processId}",
    params: [
      { name: "processId", in: "path", required: true, type: "string", description: "" },
      { name: "processHistoryType", in: "query", required: false, type: "string", description: "actioned=trueのとき、アクション履歴種別で絞り込みます。actioned=falseの場合は、このパラメーターは無視されます。" },
      { name: "nodeActionType", in: "query", required: false, type: "string", description: "permitted=trueのとき、指定したアクションが可能なプロセスに絞り込みます。返却するノードを可能なアクションで絞り込みます。permitted=falseの場合は、このパラメーターは無視されます。" },
      { name: "actioned", in: "query", required: false, type: "boolean", description: "trueを指定すると、ユーザーがアクションしたプロセスに絞り込みます。" },
      { name: "permitted", in: "query", required: false, type: "boolean", description: "trueを指定すると、ユーザーがアクション可能なプロセスに絞り込みます。" }
    ]
  },
  "getProcessWithSpecificNodeActions": {
    httpMethod: "GET",
    path: "/api/v1/my/processes/nodeActions/{processId}/{nodeId}",
    params: [
      { name: "processId", in: "path", required: true, type: "string", description: "" },
      { name: "nodeId", in: "path", required: true, type: "string", description: "" },
      { name: "processHistoryType", in: "query", required: false, type: "string", description: "actioned=trueのとき、アクション履歴種別で絞り込みます。actioned=falseの場合は、このパラメーターは無視されます。" },
      { name: "nodeActionType", in: "query", required: false, type: "string", description: "permitted=trueのとき、指定したアクションが可能なプロセスに絞り込みます。返却するノードを可能なアクションで絞り込みます。permitted=falseの場合は、このパラメーターは無視されます。" },
      { name: "actioned", in: "query", required: false, type: "boolean", description: "trueを指定すると、ユーザーがアクションしたプロセスに絞り込みます。" },
      { name: "permitted", in: "query", required: false, type: "boolean", description: "trueを指定すると、ユーザーがアクション可能なプロセスに絞り込みます。" }
    ]
  },
  "getRole": {
    httpMethod: "GET",
    path: "/api/v1/roles/{roleId}",
    params: [
      { name: "roleId", in: "path", required: true, type: "string", description: "", example: "1" }
    ]
  },
  "getRootGroup": {
    httpMethod: "GET",
    path: "/api/v1/groups/root",
    params: [

    ]
  },
  "getSession": {
    httpMethod: "GET",
    path: "/api/v1/authentication/session",
    params: [

    ]
  },
  "getSlack": {
    httpMethod: "GET",
    path: "/api/v1/slack",
    params: [

    ]
  },
  "getTenantPlanStatus": {
    httpMethod: "GET",
    path: "/api/v1/account/subscriptions/tenantPlanStatus/{authTenantId}",
    params: [
      { name: "authTenantId", in: "path", required: true, type: "string", description: "" }
    ]
  },
  "getUser": {
    httpMethod: "GET",
    path: "/api/v1/users/{userId}",
    params: [
      { name: "userId", in: "path", required: true, type: "string", description: "" }
    ]
  },
  "getUserAuthInfo": {
    httpMethod: "GET",
    path: "/api/v1/users/{userId}/userAuthInfo",
    params: [
      { name: "userId", in: "path", required: true, type: "string", description: "" }
    ]
  },
  "getUserLicenseUsage": {
    httpMethod: "GET",
    path: "/api/v1/users/license-usage",
    params: [

    ]
  },
  "getWorkflowModel": {
    httpMethod: "GET",
    path: "/api/v1/models/{modelId}",
    params: [
      { name: "modelId", in: "path", required: true, type: "string", description: "", example: "1" }
    ]
  },
  "getWorkflowModelSchemas": {
    httpMethod: "GET",
    path: "/api/v1/schemas/model",
    params: [
      { name: "type", in: "query", required: false, type: "string", description: "省略時は全スキーマを返す。" }
    ]
  },
  "getWorkflowModelWithLatestModelHistory": {
    httpMethod: "GET",
    path: "/api/v1/models/{modelId}/edit",
    params: [
      { name: "modelId", in: "path", required: true, type: "string", description: "", example: "1" }
    ]
  },
  "getWorkflowProcess": {
    httpMethod: "GET",
    path: "/api/v1/processes/{processId}",
    params: [
      { name: "processId", in: "path", required: true, type: "string", description: "", example: "1" }
    ]
  },
  "hasAccessToken": {
    httpMethod: "GET",
    path: "/api/v1/slack/hasAccessToken",
    params: [

    ]
  },
  "installSlackApp": {
    httpMethod: "POST",
    path: "/api/v1/slack/install",
    params: [

    ]
  },
  "listAccessToken": {
    httpMethod: "GET",
    path: "/api/v1/clientAuth",
    params: [
      { name: "revoked", in: "query", required: false, type: "boolean", description: "取消フラグ" }
    ]
  },
  "listApis": {
    httpMethod: "GET",
    path: "/api/v1/development/apis",
    params: [

    ]
  },
  "listCorsOrigins": {
    httpMethod: "GET",
    path: "/api/v1/cors",
    params: [
      { name: "filter", in: "query", required: false, type: "string", description: "検索条件<br>以下のような文字列を受け取って検索条件とします。<br>{\"name\":{\"equals\":\"example\"},\"price\":{\"lt\":1000}}", example: "{\"name\":{\"equals\":\"example\"}}" },
      { name: "skip", in: "query", required: false, type: "string", description: "取得時に取得せずスキップする件数<br>指定しない場合は1件目から取得します。" },
      { name: "take", in: "query", required: false, type: "string", description: "取得件数<br>指定しない場合は全件取得されます。" }
    ]
  },
  "listGroups": {
    httpMethod: "GET",
    path: "/api/v1/groups",
    params: [
      { name: "parentId", in: "query", required: true, type: "string", description: "" },
      { name: "filter", in: "query", required: false, type: "string", description: "検索条件<br>以下のような文字列を受け取って検索条件とします。<br>{\"name\":{\"equals\":\"example\"},\"price\":{\"lt\":1000}}", example: "{\"name\":{\"equals\":\"example\"}}" },
      { name: "skip", in: "query", required: false, type: "string", description: "取得時に取得せずスキップする件数<br>指定しない場合は1件目から取得します。" },
      { name: "take", in: "query", required: false, type: "string", description: "取得件数<br>指定しない場合は全件取得されます。" }
    ]
  },
  "listGroupsByUser": {
    httpMethod: "GET",
    path: "/api/v1/users/{userId}/groups",
    params: [
      { name: "userId", in: "path", required: true, type: "string", description: "" },
      { name: "filter", in: "query", required: false, type: "string", description: "検索条件<br>以下のような文字列を受け取って検索条件とします。<br>{\"name\":{\"equals\":\"example\"},\"price\":{\"lt\":1000}}", example: "{\"name\":{\"equals\":\"example\"}}" },
      { name: "skip", in: "query", required: false, type: "string", description: "取得時に取得せずスキップする件数<br>指定しない場合は1件目から取得します。" },
      { name: "take", in: "query", required: false, type: "string", description: "取得件数<br>指定しない場合は全件取得されます。" }
    ]
  },
  "listMailTemplates": {
    httpMethod: "GET",
    path: "/api/v1/mailTemplates",
    params: [

    ]
  },
  "listModelHistories": {
    httpMethod: "GET",
    path: "/api/v1/models/{modelId}/histories",
    params: [
      { name: "modelId", in: "path", required: true, type: "string", description: "", example: "1" }
    ]
  },
  "listModelWithNodeActions": {
    httpMethod: "GET",
    path: "/api/v1/my/models/nodeActions",
    params: [
      { name: "nodeActionType", in: "query", required: true, type: "string", description: "" },
      { name: "filter", in: "query", required: false, type: "string", description: "検索条件<br>以下のような文字列を受け取って検索条件とします。<br>{\"name\":{\"equals\":\"example\"},\"price\":{\"lt\":1000}}", example: "{\"name\":{\"equals\":\"example\"}}" },
      { name: "skip", in: "query", required: false, type: "string", description: "取得時に取得せずスキップする件数<br>指定しない場合は1件目から取得します。" },
      { name: "take", in: "query", required: false, type: "string", description: "取得件数<br>指定しない場合は全件取得されます。" }
    ]
  },
  "listMyModels": {
    httpMethod: "GET",
    path: "/api/v1/my/models",
    params: [
      { name: "nodeActionType", in: "query", required: false, type: "string", description: "特定のアクションが可能なモデルに絞り込みます。" },
      { name: "filter", in: "query", required: false, type: "string", description: "検索条件<br>以下のような文字列を受け取って検索条件とします。<br>{\"name\":{\"equals\":\"example\"},\"price\":{\"lt\":1000}}", example: "{\"name\":{\"equals\":\"example\"}}" },
      { name: "skip", in: "query", required: false, type: "string", description: "取得時に取得せずスキップする件数<br>指定しない場合は1件目から取得します。" },
      { name: "take", in: "query", required: false, type: "string", description: "取得件数<br>指定しない場合は全件取得されます。" }
    ]
  },
  "listMyOrganizationsTenants": {
    httpMethod: "GET",
    path: "/api/v1/account/my/organization/tenants",
    params: [

    ]
  },
  "listMyPlans": {
    httpMethod: "GET",
    path: "/api/v1/account/subscriptions/plans",
    params: [

    ]
  },
  "listMyProcesses": {
    httpMethod: "GET",
    path: "/api/v1/my/processes",
    params: [
      { name: "processHistoryType", in: "query", required: false, type: "string", description: "actioned=trueのとき、アクション履歴種別で絞り込みます。actioned=falseの場合は、このパラメーターは無視されます。" },
      { name: "nodeActionType", in: "query", required: false, type: "string", description: "permitted=trueのとき、指定したアクションが可能なプロセスに絞り込みます。permitted=falseの場合は、このパラメーターは無視されます。" },
      { name: "actioned", in: "query", required: false, type: "boolean", description: "trueを指定すると、ユーザーがアクションしたプロセスに絞り込みます。" },
      { name: "permitted", in: "query", required: false, type: "boolean", description: "trueを指定すると、ユーザーがアクション可能なプロセスに絞り込みます。" },
      { name: "filter", in: "query", required: false, type: "string", description: "検索条件<br>以下のような文字列を受け取って検索条件とします。<br>{\"name\":{\"equals\":\"example\"},\"price\":{\"lt\":1000}}", example: "{\"name\":{\"equals\":\"example\"}}" },
      { name: "skip", in: "query", required: false, type: "string", description: "取得時に取得せずスキップする件数<br>指定しない場合は1件目から取得します。" },
      { name: "take", in: "query", required: false, type: "string", description: "取得件数<br>指定しない場合は全件取得されます。" }
    ]
  },
  "listMySubscriptions": {
    httpMethod: "GET",
    path: "/api/v1/account/subscriptions",
    params: [

    ]
  },
  "listMySystemActionPolicies": {
    httpMethod: "GET",
    path: "/api/v1/my/systemActionPolicies",
    params: [

    ]
  },
  "listProcessWithNodeActions": {
    httpMethod: "GET",
    path: "/api/v1/my/processes/nodeActions",
    params: [
      { name: "processHistoryType", in: "query", required: false, type: "string", description: "actioned=trueのとき、アクション履歴種別で絞り込みます。actioned=falseの場合は、このパラメーターは無視されます。" },
      { name: "nodeActionType", in: "query", required: false, type: "string", description: "permitted=trueのとき、指定したアクションが可能なプロセスに絞り込みます。また、返却するノードを可能なアクションで絞り込みます。permitted=falseの場合は、このパラメーターは無視されます。" },
      { name: "actioned", in: "query", required: false, type: "boolean", description: "trueを指定すると、ユーザーがアクションしたプロセスに絞り込みます。" },
      { name: "permitted", in: "query", required: false, type: "boolean", description: "trueを指定すると、ユーザーがアクション可能なプロセスに絞り込みます。" },
      { name: "filter", in: "query", required: false, type: "string", description: "検索条件<br>以下のような文字列を受け取って検索条件とします。<br>{\"name\":{\"equals\":\"example\"},\"price\":{\"lt\":1000}}", example: "{\"name\":{\"equals\":\"example\"}}" },
      { name: "skip", in: "query", required: false, type: "string", description: "取得時に取得せずスキップする件数<br>指定しない場合は1件目から取得します。" },
      { name: "take", in: "query", required: false, type: "string", description: "取得件数<br>指定しない場合は全件取得されます。" }
    ]
  },
  "listRoles": {
    httpMethod: "GET",
    path: "/api/v1/roles",
    params: [
      { name: "filter", in: "query", required: false, type: "string", description: "検索条件<br>以下のような文字列を受け取って検索条件とします。<br>{\"name\":{\"equals\":\"example\"},\"price\":{\"lt\":1000}}", example: "{\"name\":{\"equals\":\"example\"}}" },
      { name: "skip", in: "query", required: false, type: "string", description: "取得時に取得せずスキップする件数<br>指定しない場合は1件目から取得します。" },
      { name: "take", in: "query", required: false, type: "string", description: "取得件数<br>指定しない場合は全件取得されます。" }
    ]
  },
  "listRolesByUser": {
    httpMethod: "GET",
    path: "/api/v1/users/{userId}/roles",
    params: [
      { name: "userId", in: "path", required: true, type: "string", description: "" },
      { name: "filter", in: "query", required: false, type: "string", description: "検索条件<br>以下のような文字列を受け取って検索条件とします。<br>{\"name\":{\"equals\":\"example\"},\"price\":{\"lt\":1000}}", example: "{\"name\":{\"equals\":\"example\"}}" },
      { name: "skip", in: "query", required: false, type: "string", description: "取得時に取得せずスキップする件数<br>指定しない場合は1件目から取得します。" },
      { name: "take", in: "query", required: false, type: "string", description: "取得件数<br>指定しない場合は全件取得されます。" }
    ]
  },
  "listSettings": {
    httpMethod: "GET",
    path: "/api/v1/settings",
    params: [

    ]
  },
  "listSystemActionPolicies": {
    httpMethod: "GET",
    path: "/api/v1/actions/systemActionPolicies",
    params: [
      { name: "userId", in: "query", required: true, type: "string", description: "" }
    ]
  },
  "listUserModelWithNodeActions": {
    httpMethod: "GET",
    path: "/api/v1/actions/models",
    params: [
      { name: "userId", in: "query", required: true, type: "string", description: "" },
      { name: "nodeActionType", in: "query", required: true, type: "string", description: "" },
      { name: "filter", in: "query", required: false, type: "string", description: "検索条件<br>以下のような文字列を受け取って検索条件とします。<br>{\"name\":{\"equals\":\"example\"},\"price\":{\"lt\":1000}}", example: "{\"name\":{\"equals\":\"example\"}}" },
      { name: "skip", in: "query", required: false, type: "string", description: "取得時に取得せずスキップする件数<br>指定しない場合は1件目から取得します。" },
      { name: "take", in: "query", required: false, type: "string", description: "取得件数<br>指定しない場合は全件取得されます。" }
    ]
  },
  "listUserProcessWithNodeActions": {
    httpMethod: "GET",
    path: "/api/v1/actions/processes",
    params: [
      { name: "userId", in: "query", required: true, type: "string", description: "" },
      { name: "nodeActionType", in: "query", required: true, type: "string", description: "" },
      { name: "filter", in: "query", required: false, type: "string", description: "検索条件<br>以下のような文字列を受け取って検索条件とします。<br>{\"name\":{\"equals\":\"example\"},\"price\":{\"lt\":1000}}", example: "{\"name\":{\"equals\":\"example\"}}" },
      { name: "skip", in: "query", required: false, type: "string", description: "取得時に取得せずスキップする件数<br>指定しない場合は1件目から取得します。" },
      { name: "take", in: "query", required: false, type: "string", description: "取得件数<br>指定しない場合は全件取得されます。" }
    ]
  },
  "listUsers": {
    httpMethod: "GET",
    path: "/api/v1/users",
    params: [
      { name: "filter", in: "query", required: false, type: "string", description: "検索条件<br>以下のような文字列を受け取って検索条件とします。<br>{\"name\":{\"equals\":\"example\"},\"price\":{\"lt\":1000}}", example: "{\"name\":{\"equals\":\"example\"}}" },
      { name: "skip", in: "query", required: false, type: "string", description: "取得時に取得せずスキップする件数<br>指定しない場合は1件目から取得します。" },
      { name: "take", in: "query", required: false, type: "string", description: "取得件数<br>指定しない場合は全件取得されます。" }
    ]
  },
  "listWorkflowModels": {
    httpMethod: "GET",
    path: "/api/v1/models",
    params: [
      { name: "filter", in: "query", required: false, type: "string", description: "検索条件<br>以下のような文字列を受け取って検索条件とします。<br>{\"name\":{\"equals\":\"example\"},\"price\":{\"lt\":1000}}", example: "{\"name\":{\"equals\":\"example\"}}" },
      { name: "skip", in: "query", required: false, type: "string", description: "取得時に取得せずスキップする件数<br>指定しない場合は1件目から取得します。" },
      { name: "take", in: "query", required: false, type: "string", description: "取得件数<br>指定しない場合は全件取得されます。" }
    ]
  },
  "listWorkflowProcesses": {
    httpMethod: "GET",
    path: "/api/v1/processes",
    params: [
      { name: "filter", in: "query", required: false, type: "string", description: "検索条件<br>以下のような文字列を受け取って検索条件とします。<br>{\"name\":{\"equals\":\"example\"},\"price\":{\"lt\":1000}}", example: "{\"name\":{\"equals\":\"example\"}}" },
      { name: "skip", in: "query", required: false, type: "string", description: "取得時に取得せずスキップする件数<br>指定しない場合は1件目から取得します。" },
      { name: "take", in: "query", required: false, type: "string", description: "取得件数<br>指定しない場合は全件取得されます。" }
    ]
  },
  "listWorkflowProcessHistories": {
    httpMethod: "GET",
    path: "/api/v1/processes/{processId}/histories",
    params: [
      { name: "processId", in: "path", required: true, type: "string", description: "" }
    ]
  },
  "publishWorkflowModel": {
    httpMethod: "PUT",
    path: "/api/v1/models/{modelId}/publish",
    params: [
      { name: "modelId", in: "path", required: true, type: "string", description: "", example: "1" }
    ]
  },
  "rejectWorkflowProcess": {
    httpMethod: "POST",
    path: "/api/v1/engine/reject/{processId}",
    params: [
      { name: "processId", in: "path", required: true, type: "string", description: "" }
    ],
    requestBody: {
      dtoName: "body",
      properties: [

      ]
    }
  },
  "rejectWorkflowProcessWithNodeId": {
    httpMethod: "POST",
    path: "/api/v1/engine/reject/{processId}/{nodeId}",
    params: [
      { name: "processId", in: "path", required: true, type: "string", description: "" },
      { name: "nodeId", in: "path", required: true, type: "string", description: "" }
    ],
    requestBody: {
      dtoName: "body",
      properties: [

      ]
    }
  },
  "restoreWorkflowProcessHistory": {
    httpMethod: "POST",
    path: "/api/v1/processes/{processId}/restore-history/{historyId}",
    params: [
      { name: "processId", in: "path", required: true, type: "string", description: "", example: "1" },
      { name: "historyId", in: "path", required: true, type: "string", description: "", example: "123" }
    ],
    requestBody: {
      dtoName: "restoreHistoryDto",
      properties: [
        { name: "scope", type: "object", description: "復元スコープ\n- all: 全ての情報を復元（デフォルト）\n- data: データのみを復元\n- state: ワークフロー状態のみを復元", required: false, example: "all" }
      ]
    }
  },
  "revertWorkflowProcess": {
    httpMethod: "POST",
    path: "/api/v1/engine/revert/{processId}/{nodeId}",
    params: [
      { name: "processId", in: "path", required: true, type: "string", description: "" },
      { name: "nodeId", in: "path", required: true, type: "string", description: "" }
    ]
  },
  "revokeAccessToken": {
    httpMethod: "POST",
    path: "/api/v1/slack/revoke",
    params: [

    ]
  },
  "revokeToken": {
    httpMethod: "POST",
    path: "/api/v1/clientAuth/oauth/revoke",
    params: [

    ]
  },
  "saveWorkflowModel": {
    httpMethod: "PUT",
    path: "/api/v1/models/{modelId}",
    params: [
      { name: "modelId", in: "path", required: true, type: "string", description: "", example: "1" }
    ],
    requestBody: {
      dtoName: "updateModelDto",
      properties: [
        { name: "name", type: "string", description: "モデル名", required: true, example: "経費申請・承認フロー" },
        { name: "description", type: "string", description: "説明", required: false, example: "経費申請の承認を行います。" },
        { name: "definition", type: "object", description: "ワークフロー定義", required: true },
        { name: "dataSchema", type: "object", description: "データスキーマ", required: true },
        { name: "policy", type: "object", description: "データアクセスポリシー", required: true }
      ]
    }
  },
  "saveWorkflowProcess": {
    httpMethod: "PUT",
    path: "/api/v1/engine/save/{processId}",
    params: [
      { name: "processId", in: "path", required: true, type: "string", description: "" }
    ]
  },
  "saveWorkflowProcessWithNodeId": {
    httpMethod: "PUT",
    path: "/api/v1/engine/save/{processId}/{nodeId}",
    params: [
      { name: "processId", in: "path", required: true, type: "string", description: "" },
      { name: "nodeId", in: "path", required: true, type: "string", description: "" }
    ]
  },
  "sendAgentMessage": {
    httpMethod: "POST",
    path: "/api/v1/ai/agent",
    params: [

    ],
    requestBody: {
      dtoName: "agentChatDto",
      properties: [
        { name: "mode", type: "object", description: "アシスタントの回答モード。省略時は developer_api（後方互換）。\n新規セッション開始時のみ参照され、agentId 指定時は無視される。", required: false },
        { name: "message", type: "string", description: "ユーザーメッセージ", required: true },
        { name: "agentId", type: "string", description: "前回のレスポンスで返された agentId。指定するとその会話を継続する。\n省略時は新しい会話を開始する。", required: false }
      ]
    }
  },
  "sendInitializeMyPasswordEmail": {
    httpMethod: "POST",
    path: "/api/v1/authentication/sendInitializePasswordEmail",
    params: [

    ]
  },
  "sendInitializePasswordEmail": {
    httpMethod: "POST",
    path: "/api/v1/authentication/sendInitializePasswordEmail/{email}",
    params: [
      { name: "email", in: "path", required: true, type: "string", description: "" }
    ]
  },
  "sendUserInvitationEmail": {
    httpMethod: "POST",
    path: "/api/v1/users/{userId}/sendInvitationEmail",
    params: [
      { name: "userId", in: "path", required: true, type: "string", description: "" }
    ]
  },
  "signInWithEmailAndPassword": {
    httpMethod: "POST",
    path: "/api/v1/authentication/signin",
    params: [

    ],
    requestBody: {
      dtoName: "signInDto",
      properties: [
        { name: "authTenantId", type: "string", description: "AuthテナントID", required: true, example: "mytenant-xhwpda" },
        { name: "email", type: "string", description: "メールアドレス", required: true, example: "user@acomo.app" },
        { name: "password", type: "string", description: "パスワード", required: true, example: "password" }
      ]
    }
  },
  "signOut": {
    httpMethod: "POST",
    path: "/api/v1/authentication/signout",
    params: [

    ]
  },
  "startWorkflowProcess": {
    httpMethod: "POST",
    path: "/api/v1/engine/start/{modelId}",
    params: [
      { name: "modelId", in: "path", required: true, type: "string", description: "" }
    ]
  },
  "submitWorkflowProcess": {
    httpMethod: "POST",
    path: "/api/v1/engine/submit/{processId}",
    params: [
      { name: "processId", in: "path", required: true, type: "string", description: "" }
    ],
    requestBody: {
      dtoName: "body",
      properties: [

      ]
    }
  },
  "submitWorkflowProcessWithNodeId": {
    httpMethod: "POST",
    path: "/api/v1/engine/submit/{processId}/{nodeId}",
    params: [
      { name: "processId", in: "path", required: true, type: "string", description: "" },
      { name: "nodeId", in: "path", required: true, type: "string", description: "" }
    ],
    requestBody: {
      dtoName: "body",
      properties: [

      ]
    }
  },
  "updateAccessToken": {
    httpMethod: "PUT",
    path: "/api/v1/clientAuth/{clientAccessTokenId}",
    params: [
      { name: "clientAccessTokenId", in: "path", required: true, type: "string", description: "" }
    ]
  },
  "updateCorsOrigins": {
    httpMethod: "POST",
    path: "/api/v1/cors/{id}",
    params: [
      { name: "id", in: "path", required: true, type: "string", description: "" }
    ],
    requestBody: {
      dtoName: "updateCorsAllowedOriginDto",
      properties: [
        { name: "url", type: "string", description: "", required: true },
        { name: "description", type: "string", description: "", required: true }
      ]
    }
  },
  "updateGroup": {
    httpMethod: "PUT",
    path: "/api/v1/groups/{groupId}",
    params: [
      { name: "groupId", in: "path", required: true, type: "string", description: "", example: "1" }
    ]
  },
  "updateMailTemplate": {
    httpMethod: "PUT",
    path: "/api/v1/mailTemplates/{type}",
    params: [
      { name: "type", in: "path", required: true, type: "string", description: "" }
    ],
    requestBody: {
      dtoName: "updateMailTemplateDto",
      properties: [
        { name: "subject", type: "string", description: "件名", required: true, example: "acomo「{{authTenantId}}」テナントへの招待" },
        { name: "bodyText", type: "string", description: "プレーンテキスト本文", required: true }
      ]
    }
  },
  "updateMyOrganization": {
    httpMethod: "PUT",
    path: "/api/v1/account/my/organization",
    params: [

    ],
    requestBody: {
      dtoName: "updateOrganizationDto",
      properties: [
        { name: "name", type: "string", description: "組織名", required: true, example: "acomo.inc" }
      ]
    }
  },
  "updateMyOrganizationsTenant": {
    httpMethod: "PUT",
    path: "/api/v1/account/my/organization/tenants/{tenantId}",
    params: [
      { name: "tenantId", in: "path", required: true, type: "string", description: "" }
    ],
    requestBody: {
      dtoName: "updateTenantDto",
      properties: [
        { name: "name", type: "string", description: "テナント名", required: true }
      ]
    }
  },
  "updateRole": {
    httpMethod: "PUT",
    path: "/api/v1/roles/{roleId}",
    params: [
      { name: "roleId", in: "path", required: true, type: "string", description: "", example: "1" }
    ]
  },
  "updateSettings": {
    httpMethod: "PUT",
    path: "/api/v1/settings",
    params: [

    ]
  },
  "updateSlack": {
    httpMethod: "PUT",
    path: "/api/v1/slack",
    params: [

    ]
  },
  "updateUser": {
    httpMethod: "PUT",
    path: "/api/v1/users/{userId}",
    params: [
      { name: "userId", in: "path", required: true, type: "string", description: "", example: "1" }
    ]
  },
  "updateWorkflowProcess": {
    httpMethod: "PUT",
    path: "/api/v1/processes/{processId}",
    params: [
      { name: "processId", in: "path", required: true, type: "string", description: "", example: "1" }
    ],
    requestBody: {
      dtoName: "updateProcessDto",
      properties: [
        { name: "name", type: "string", description: "プロセス名", required: false, example: "経費申請: Aさん" },
        { name: "description", type: "string", description: "説明", required: false, example: "2023年3月分の経費申請です。" }
      ]
    }
  },
  "uploadMyProcessDataFile": {
    httpMethod: "POST",
    path: "/api/v1/my/processes/{processId}/files/upload",
    params: [
      { name: "processId", in: "path", required: true, type: "string", description: "", example: "1" }
    ],
    requestBody: {
      dtoName: "createProcessFileDto",
      properties: [
        { name: "property", type: "string", description: "プロパティ（データ項目名）", required: true, example: "attachmentFiles" },
        { name: "fileName", type: "string", description: "ファイル名", required: true, example: "領収書.pdf" }
      ]
    }
  },
  "uploadProcessDataFile": {
    httpMethod: "POST",
    path: "/api/v1/processes/{processId}/files/upload",
    params: [
      { name: "processId", in: "path", required: true, type: "string", description: "", example: "1" }
    ],
    requestBody: {
      dtoName: "createProcessFileDto",
      properties: [
        { name: "property", type: "string", description: "プロパティ（データ項目名）", required: true, example: "attachmentFiles" },
        { name: "fileName", type: "string", description: "ファイル名", required: true, example: "領収書.pdf" }
      ]
    }
  },
  "validateExpression": {
    httpMethod: "GET",
    path: "/api/v1/models/validate/{expressionJson}",
    params: [
      { name: "expressionJson", in: "path", required: true, type: "string", description: "" }
    ]
  },
  "validateWorkflowModelSchema": {
    httpMethod: "POST",
    path: "/api/v1/schemas/model/validate",
    params: [

    ],
    requestBody: {
      dtoName: "validateWorkflowModelSchemaRequest",
      properties: [
        { name: "definition", type: "object", description: "", required: false },
        { name: "dataSchema", type: "object", description: "", required: false },
        { name: "policy", type: "object", description: "", required: false }
      ]
    }
  }
};
